import React,{Component} from 'react';
import PropTypes from 'prop-types';
import { PuzzleCard}  from 'dabbl-react-components';

import { Row, Col } from 'reactstrap';

import find from 'lodash/find';

import ProgressBarSVG from '../../../shared/components/ProgressBarSVG';

class RatableResults extends Component {
  render(){
    const { engagement, engagementKPIs } = this.props,
      answerKPI = find(engagementKPIs.answerKPIs, (a) => a.answer === '0') || {answersNum:0},
      answerKPI1 = find(engagementKPIs.answerKPIs, (a) => a.answer === '1') || {answersNum:0};
      answerKPI.answersNum += answerKPI1.answersNum;

      return (
        <div className='EngagementResults'>
          <Row style={{pageBreakInside:'avoid'}}>
            <Col xs='4'>
              <br />
              <br />
              <h6>Puzzle</h6>

              <img
                src={engagement.firstImageURL}
                style={{maxWidth:200,borderRadius:10}}
                alt='Puzzle Image'
              />
            </Col>
            <Col xs='8'>
              <br />
              <br />
              <br />
              <br />
              <br />
              <div>
                <Row tyle={{pageBreakInside:'avoid'}}>
                  <Col xs='4'>
                    Completions:
                  </Col>
                  <Col xs='8'>
                    { answerKPI.answersNum}
                  </Col>
                </Row>
                <Row tyle={{pageBreakInside:'avoid'}}>
                  <Col xs='4'>
                    Average Time Spent:
                  </Col>
                  <Col xs='8'>
                    { (engagementKPIs.avgTimeSpent).toFixed(1)} seconds
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <br />
              <br />
            </Col>
          </Row>
        </div>
      )
  }
}

RatableResults.propTypes = {
  engagement:PropTypes.object.isRequired,
  engagementKPIs:PropTypes.object.isRequired
};


export default RatableResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/PuzzleResults.js